/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable } from '@angular/core'
import { EmailCommunicationDto } from '../../../../../apps/myprofile-ui/src/app/services/email/email.service'

@Injectable({
  providedIn: 'root',
})
export class MyProfileEmailWidgetService {
  // Helper fn to sort emails by id and always put the one which the porscheID attribute first
  static sortEmails(addresses: EmailCommunicationDto[]): EmailCommunicationDto[] {
    return (
      addresses
        .sort((emailItemA: EmailCommunicationDto, emailItemB: EmailCommunicationDto) => {
          return (emailItemA.emailId ?? '') < (emailItemB.emailId ?? '') ? -1 : 1
        })
        .sort((emailA: EmailCommunicationDto) => {
          return emailA.isStandard ? -1 : 1
        })
        // Sort by porsche ID
        .sort((emailA: EmailCommunicationDto) => {
          return emailA.isPorscheId ? -1 : 1
        })
    )
  }

  static pickNextStandard(addresses: EmailCommunicationDto[]): EmailCommunicationDto | undefined {
    if (!addresses.length || addresses.some((anAddress) => anAddress.isStandard)) {
      return undefined
    }
    return addresses.find((anAddress) => anAddress.isVerified) ?? addresses[0]
  }
}
